<main class="page-main">
	<app-page-sub-nav [data]="pageSubNavData" [currVisible]="currVisible"></app-page-sub-nav>
	<section class="page-section" id="overview">
		<h2 id="sectionTitleOverview" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('overview')">
			Overview <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<app-external-resource [componentName]="'Bar Chart'" [includeDescription]="true"
			[otherNames]="true"></app-external-resource>
	</section>
	<section class="page-section" id="example">
		<h2 id="sectionTitleExample" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('example')">
			Live example <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<form class="example-container k-body">
			<div class="page-live-header">
				<div class="page-live-header">
					<select class="page-live-example-select" (change)="changeCurrLive($event)" title="Change Example">
						<option value="default">Default</option>
						<option value="severity">Severity</option>
						<option value="status">Status</option>
					</select>
					<select class="page-live-example-select" (change)="changeBarOption($event)" title="Change Example">
						<option value="vertical">Vertical</option>
						<option value="horizontal">Horizontal</option>
						<option value="stacked">Stacked</option>
					</select>
					<app-theme-switcher></app-theme-switcher>
				</div>
			</div>
			<div class="page-live-example-content">
				<ng-container *ngIf="selectedDataType == 'default'">
					<kendo-chart [transitions]="true" [pannable]="true" [zoomable]="true"
						[popupSettings]="{ popupClass: 'kendo-chart-tooltip' }" class="show-default-light">
						<kendo-chart-value-axis>
							<kendo-chart-value-axis-item *ngFor="let item of valueAxes" [name]="item.name"
								[title]="item.title"> </kendo-chart-value-axis-item>
						</kendo-chart-value-axis>
						<kendo-chart-category-axis>
							<kendo-chart-category-axis-item [labels]="labelOptions"> </kendo-chart-category-axis-item>
						</kendo-chart-category-axis>
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item *ngFor="let groupedResult of groupedData"
								[data]="groupedResult.items" [name]="groupedResult.value" field="data"
								categoryField="categoryName" noteTextField="labelName" colorField="colorString"
								[notes]="notes" [type]="selectedBarType" [stack]="stackFlag">
								<kendo-chart-series-item-tooltip>
									<ng-template let-category="category" let-value="value" let-series="series">
										<div class="toolTip">
											<div>{{ series.name }}</div>
											<div>
												{{ value }}
											</div>
										</div>
									</ng-template>
								</kendo-chart-series-item-tooltip>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
					<kendo-chart [transitions]="true" [pannable]="true" [zoomable]="true"
						[popupSettings]="{ popupClass: 'kendo-chart-tooltip' }" class="show-default-dark">
						<kendo-chart-value-axis>
							<kendo-chart-value-axis-item *ngFor="let item of valueAxes" [name]="item.name"
								[title]="item.title"> </kendo-chart-value-axis-item>
						</kendo-chart-value-axis>
						<kendo-chart-category-axis>
							<kendo-chart-category-axis-item [labels]="labelOptions"> </kendo-chart-category-axis-item>
						</kendo-chart-category-axis>
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item *ngFor="let groupedResult of groupedData"
								[data]="groupedResult.items" [name]="groupedResult.value" field="data"
								categoryField="categoryName" noteTextField="labelName" colorField="colorString"
								[notes]="notes" [type]="selectedBarType" [stack]="stackFlag">
								<kendo-chart-series-item-tooltip>
									<ng-template let-category="category" let-value="value" let-series="series">
										<div class="toolTip">
											<div>{{ series.name }}</div>
											<div>
												{{ value }}
											</div>
										</div>
									</ng-template>
								</kendo-chart-series-item-tooltip>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
				</ng-container>
				<ng-container *ngIf="selectedDataType == 'severity'">
					<kendo-chart [transitions]="true" [pannable]="true" [zoomable]="true"
						[popupSettings]="{ popupClass: 'kendo-chart-tooltip' }" class="show-default-light">
						<kendo-chart-value-axis>
							<kendo-chart-value-axis-item *ngFor="let item of valueAxes" [name]="item.name"
								[title]="item.title"> </kendo-chart-value-axis-item>
						</kendo-chart-value-axis>
						<kendo-chart-category-axis>
							<kendo-chart-category-axis-item [labels]="labelOptions"> </kendo-chart-category-axis-item>
						</kendo-chart-category-axis>
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item
								*ngFor="let groupedResult of groupedSeverityLightData" [data]="groupedResult.items"
								[name]="groupedResult.value" field="data" categoryField="categoryName"
								noteTextField="labelName" colorField="colorString" [notes]="notes"
								[type]="selectedBarType" [stack]="stackFlag">
								<kendo-chart-series-item-tooltip>
									<ng-template let-category="category" let-value="value" let-series="series">
										<div class="toolTip">
											<div>{{ series.name }}</div>
											<div>
												{{ value }}
											</div>
										</div>
									</ng-template>
								</kendo-chart-series-item-tooltip>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
					<kendo-chart [transitions]="true" [pannable]="true" [zoomable]="true"
						[popupSettings]="{ popupClass: 'kendo-chart-tooltip' }" class="show-default-dark">
						<kendo-chart-value-axis>
							<kendo-chart-value-axis-item *ngFor="let item of valueAxes" [name]="item.name"
								[title]="item.title"> </kendo-chart-value-axis-item>
						</kendo-chart-value-axis>
						<kendo-chart-category-axis>
							<kendo-chart-category-axis-item [labels]="labelOptions"> </kendo-chart-category-axis-item>
						</kendo-chart-category-axis>
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item
								*ngFor="let groupedResult of groupedSeverityLightData" [data]="groupedResult.items"
								[name]="groupedResult.value" field="data" categoryField="categoryName"
								noteTextField="labelName" colorField="colorString" [notes]="notes"
								[type]="selectedBarType" [stack]="stackFlag">
								<kendo-chart-series-item-tooltip>
									<ng-template let-category="category" let-value="value" let-series="series">
										<div class="toolTip">
											<div>{{ series.name }}</div>
											<div>
												{{ value }}
											</div>
										</div>
									</ng-template>
								</kendo-chart-series-item-tooltip>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
				</ng-container>
				<ng-container *ngIf="selectedDataType == 'status'">
					<kendo-chart [transitions]="true" [pannable]="true" [zoomable]="true"
						[popupSettings]="{ popupClass: 'kendo-chart-tooltip' }" class="show-default-light">
						<kendo-chart-value-axis>
							<kendo-chart-value-axis-item *ngFor="let item of valueAxes" [name]="item.name"
								[title]="item.title"> </kendo-chart-value-axis-item>
						</kendo-chart-value-axis>
						<kendo-chart-category-axis>
							<kendo-chart-category-axis-item [labels]="labelOptions"> </kendo-chart-category-axis-item>
						</kendo-chart-category-axis>
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item
								*ngFor="let groupedResult of groupedStatusLightData" [data]="groupedResult.items"
								[name]="groupedResult.value" field="data" categoryField="categoryName"
								noteTextField="labelName" colorField="colorString" [notes]="notes"
								[type]="selectedBarType" [stack]="stackFlag">
								<kendo-chart-series-item-tooltip>
									<ng-template let-category="category" let-value="value" let-series="series">
										<div class="toolTip">
											<div>{{ series.name }}</div>
											<div>
												{{ value }}
											</div>
										</div>
									</ng-template>
								</kendo-chart-series-item-tooltip>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
					<kendo-chart [transitions]="true" [pannable]="true" [zoomable]="true"
						[popupSettings]="{ popupClass: 'kendo-chart-tooltip' }" class="show-default-dark">
						<kendo-chart-value-axis>
							<kendo-chart-value-axis-item *ngFor="let item of valueAxes" [name]="item.name"
								[title]="item.title"> </kendo-chart-value-axis-item>
						</kendo-chart-value-axis>
						<kendo-chart-category-axis>
							<kendo-chart-category-axis-item [labels]="labelOptions"> </kendo-chart-category-axis-item>
						</kendo-chart-category-axis>
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item *ngFor="let groupedResult of groupedStatusLightData"
								[data]="groupedResult.items" [name]="groupedResult.value" field="data"
								categoryField="categoryName" noteTextField="labelName" colorField="colorString"
								[notes]="notes" [type]="selectedBarType" [stack]="stackFlag">
								<kendo-chart-series-item-tooltip>
									<ng-template let-category="category" let-value="value" let-series="series">
										<div class="toolTip">
											<div>{{ series.name }}</div>
											<div>
												{{ value }}
											</div>
										</div>
									</ng-template>
								</kendo-chart-series-item-tooltip>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
				</ng-container>
			</div>
		</form>
	</section>
	<section class="page-section" id="dev">
		<h2 id="sectionTitleDev" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('dev')">
			Developer resources <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="dev-started">
			<h3 id="subSectionTitleDevStarted" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-started')">
				Getting started <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<p>Added to your project's app.module.ts file:</p>
			<code style="margin-top: 10px">import &#123; ChartsModule &#125; from
				'&#64;progress/kendo-angular-charts';</code>
			<code style="margin-top: 10px">import 'hammerjs';</code>
		</section>
		<section class="page-sub-section" id="dev-code">
			<h3 id="subSectionTitleDevCode" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-code')">
				Code examples <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<kendo-tabstrip #tabs class="code-example-tabstrip">
				<kendo-tabstrip-tab title="Vertical" [selected]="true">
					<ng-template kendoTabContent>
						<div class="content">
							<pre prism class="dark">
								{{ VerticalBarChartHTML }}
							</pre>
							<pre prism class="dark">
								{{ VerticalBarChartTs }}
							</pre>
						</div>
					</ng-template>
				</kendo-tabstrip-tab>
				<kendo-tabstrip-tab title="Horizontal">
					<ng-template kendoTabContent>
						<div class="content">
							<pre prism class="dark">
								{{ HorizontalBarChartHTML }}
							</pre>
							<pre prism class="dark">
								{{ HorizontalBarChartTs }}
							</pre>
						</div>
					</ng-template>
				</kendo-tabstrip-tab>
				<kendo-tabstrip-tab title="Stacked">
					<ng-template kendoTabContent>
						<div class="content">
							<pre prism class="dark">
								{{ StackedBarChartHTML }}
							</pre>
							<pre prism class="dark">
								{{ StackedBarChartTs }}
							</pre>
						</div>
					</ng-template>
				</kendo-tabstrip-tab>
			</kendo-tabstrip>
		</section>
		<section class="page-sub-section" id="dev-api">
			<h3 id="subSectionTitleDevApi" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-api')">
				API <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<a class="page-kendo-link" target="_blank"
						href="https://www.telerik.com/kendo-angular-ui/components/charts/api/"><svg
							xmlns="http://www.w3.org/2000/svg" width="18px" height="18" viewBox="0 0 49 60.3">
							<path fill="#5ce500"
								d="M11.2 14.9L0 21.3l17.4 10.1v20.1l11.2-6.4c.5-.3.9-1 .9-1.6V24.4L13 14.9c-.5-.3-1.3-.3-1.8 0z">
							</path>
							<path fill="#5ce500"
								d="M12.1 48.4V34.5L0 41.5zM25 .2c-.5-.3-1.3-.3-1.8 0L10.7 7.4l24.1 13.9v27.9L47.3 42c.5-.3.9-1 .9-1.6V13.6L25 .2z">
							</path>
						</svg>Kendo Charts API</a>
				</li>
				<li class="page-section-list-item">
					Refer to the
					<a href="components/bar-chart#behaviors">behaviors section</a>
					to see supported component features.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="styles">
		<h2 id="sectionTitleStyles" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('styles')">
			Styles <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-section-list">
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (light theme)
					</summary>

					<span class="page-style-list-title">Default</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefault" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Severity</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultSeverity" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Status</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultStatus" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Tooltip</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesTooltipDefault" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (dark theme)
					</summary>
					<span class="page-style-list-title">Default</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDark" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Severity</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkSeverity" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Status</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkStatus" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Tooltip</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesTooltipDark" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Typography</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTypography" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Tooltip</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTooltipTypography" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Structure</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesStructure" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Tooltip</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTooltipStructure" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
		</ul>
	</section>
	<section class="page-section" id="behaviors">
		<h2 id="sectionTitleBehaviors" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('behaviors')">
			Behaviors <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="behaviors-legend-visibility">
			<h3 id="subSectionTitleBehaviorsLegend" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-legend-visibility')">
				Legend visibility <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>

			<ul class="page-section-list">
				<li class="page-section-list-item">
					The chart's legend displays the data. Selecting the legend
					items toggles the visibility of the data. When the legend
					item is selected, the data is hidden from the chart and the
					text appears greyed out on the legend.
				</li>
				<li class="page-section-list-item">
					All data should be displayed by default. Users can then
					decide what they want to hide or show.
				</li>
				<li class="page-section-list-item">
					Don't hide the legend completely, unless only one type of
					data is displayed.
				</li>
				<li class="page-section-list-item">
					For more information, read <a class="page-kendo-link" target="_blank"
						href="https://www.telerik.com/kendo-angular-ui/components/charts/elements/legend/"><svg
							xmlns="http://www.w3.org/2000/svg" width="18px" height="18" viewBox="0 0 49 60.3">
							<path fill="#5ce500"
								d="M11.2 14.9L0 21.3l17.4 10.1v20.1l11.2-6.4c.5-.3.9-1 .9-1.6V24.4L13 14.9c-.5-.3-1.3-.3-1.8 0z">
							</path>
							<path fill="#5ce500"
								d="M12.1 48.4V34.5L0 41.5zM25 .2c-.5-.3-1.3-.3-1.8 0L10.7 7.4l24.1 13.9v27.9L47.3 42c.5-.3.9-1 .9-1.6V13.6L25 .2z">
							</path>
						</svg>Kendo legend guide</a>.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-tooltip">
			<h3 id="subSectionTitleBehaviorsTooltip" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-tooltip')">
				Tooltip <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<a href="components/tooltip">Tooltips</a> for bar charts contain any necessary information for
					understanding the part of a chart
					being referenced. This can include helpful color blocks or other details like percentages.
					These tooltips are still intended to be concise.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="behaviors-pan-and-zoom">
			<h3 id="subSectionTitleBehaviorsPanZoom" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-pan-and-zoom')">
				Pan and zoom <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Bar charts have a feature that allows users to zoom in and out to get a closer look at data points.
					For more
					information, read <a class="page-kendo-link" target="_blank"
						href="https://www.telerik.com/kendo-angular-ui/components/charts/pan-zoom/"><svg
							xmlns="http://www.w3.org/2000/svg" width="18px" height="18" viewBox="0 0 49 60.3">
							<path fill="#5ce500"
								d="M11.2 14.9L0 21.3l17.4 10.1v20.1l11.2-6.4c.5-.3.9-1 .9-1.6V24.4L13 14.9c-.5-.3-1.3-.3-1.8 0z">
							</path>
							<path fill="#5ce500"
								d="M12.1 48.4V34.5L0 41.5zM25 .2c-.5-.3-1.3-.3-1.8 0L10.7 7.4l24.1 13.9v27.9L47.3 42c.5-.3.9-1 .9-1.6V13.6L25 .2z">
							</path>
						</svg>Kendo's pan and zoom guide</a>.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="variations">
		<h2 id="sectionTitleVariations" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('variations')">
			Variations <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="variations-horizontal-and-vertical">
			<h3 id="sectionTitleVariationsHorizontalVertical" class="page-sub-section-title"
				title="Copy Link to Clipboard" (click)="copyToClipboard('variations-horizontal-and-vertical')">
				Horizontal and vertical <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Bars on a bar chart can be displayed horizontally or vertically. The same variation should be used
					consistently
					throughout a product to help users become familiar with how data is displayed. Vertical is the more
					common and
					recognizable display, but horizontal can be useful for charts with long labels.
				</li>
				<li class="page-section-list-item">
					<a class="page-general-link" target="_blank"
						href="https://www.nngroup.com/articles/choosing-chart-types/">Source: NN/g &#8212; Choosing
						Chart Types</a>
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="variations-stacked-and-grouped">
			<h3 id="sectionTitleVariationsStackedGrouped" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('variations-stacked-and-grouped')">
				Stacked and grouped <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Stacked bar charts have bars that are divided into subparts. These subparts represent a portion of
					the total value.
					Stacked bar charts can be helpful to simultaneously compare totals while also representing
					individual data points.
					Stacked bar charts can also be divided into groups, with two or more bars grouped together into a
					category.
				</li>
				<li class="page-section-list-item">
					UX research shows that stacked bar charts can be difficult to understand. If space allows, use a
					series of bar charts
					instead of a single stacked bar chart.
				</li>
				<li class="page-section-list-item">
					<a class="page-general-link" target="_blank"
						href="https://www.nngroup.com/articles/choosing-chart-types/">Source: NN/g &#8212; Choosing
						Chart Types</a>
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="usage">
		<h2 id="sectionTitleUsage" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('usage')">
			Usage guidelines <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="usage-general-use">
			<h3 id="subSectionTitleUsageGeneralUse" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-general-use')">
				General <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-do-list-title">Do use bar charts:</span>
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							When comparing parts of a bigger set of data,
							highlighting different categories, or showing change
							over time.
						</li>
						<li class="page-section-list-item">
							If you want to illustrate both positive and negative
							values in the dataset.
						</li>
					</ul>
				</li>
				<li class="page-section-list-item" style="margin-top: 5px">
					<span class="page-section-do-list-title">Don’t use bar charts:</span>
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							If you're using multiple data points.
						</li>
						<li class="page-section-list-item">
							If you have many categories. Avoid overloading your
							graph. Your graph shouldn't have more than 7 bars.
						</li>
					</ul>
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-severity">
			<h3 id="subSectionTitleUsageSeverity" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-severity')">
				Severity <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					If you’re using bar charts to indicate severity, use the labels outlined in <a
						href="guidelines/severity">severity guidelines</a> and the colors in the <a
						href="components/bar-chart#styles">styles section</a>.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-status">
			<h3 id="subSectionTitleUsageStatus" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-status')">
				Status <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					If you’re using bar charts to display the statuses from a collection of items, the statuses are
					success, warning, error,
					and informational. Refer to the colors in the <a href="components/bar-chart#styles">styles
						section</a>.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-content">
			<h3 id="subSectionTitleUsageContent" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-content')">
				Content <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Labels</span>
					Bar chart labels should be short, while still clearly describing the data. Use title case.
				</li>
				<li class="page-section-list-item">
					<span class="page-section-list-item-sub-title">Tooltips</span>
					Bar chart tooltips should contain the data value and name.
					<a href="components/tooltip#variations-chart-tooltips">Review tooltip guidance</a> for more best practices.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="related">
		<h2 id="sectionTitleRelated" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('related')">
			Related <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<span class="page-related-list-title">Referenced in this section:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
                <a href="guidelines/colors">Colors guidelines</a>
            </li>
			<li class="page-related-list-item">
				<a href="guidelines/data-visualization">Data visualization guidelines</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/donut-chart">Donut chart component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/line-chart">Line chart component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/pie-chart">Pie chart component</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/severity">Severity guidelines</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/tooltip">Tooltip component</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/typography">Typography guidelines</a>
			</li>
		</ul>
	</section>
	<section class="page-section" id="history">
		<h2 id="sectionTitleHistory" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('history')">
			Revision history <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-history-list">
			<li class="page-history-list-item" *ngFor="
						let subItem of changelogService.getChangelogBySection(
							'Bar Chart Component'
						)
					">
				<span class="page-history-list-item-title">{{
					changelogService.formatDate(subItem.changeDate)
					}}</span>
				<a class="page-history-list-item-link" target="_blank" *ngIf="subItem.workId != ''" [attr.href]="
							'https://beyondtrust.atlassian.net/jira/software/c/projects/SDS/issues/' +
							subItem.workId
						">[{{ subItem.workId }}]</a>{{ subItem.changeName }}
			</li>
		</ul>
	</section>
</main>